/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/operators/mod.json`.

import type { PromqlOperatorDefinition } from '../../definition_types';

/**
 * Returns the remainder of dividing the left operand by the right operand element-wise. For vector–vector operations, the metric name is dropped.
 *
 * @example
 * metric % 10
 */
const definition: PromqlOperatorDefinition = {
  type: 'operator',
  operator: '%',
  name: 'mod',
  signatures: [
    {
      params: [
        {
          name: 'lhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
        {
          name: 'rhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
        {
          name: 'rhs',
          type: 'scalar',
          optional: false,
          description: 'Scalar.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'scalar',
          optional: false,
          description: 'Scalar.',
        },
        {
          name: 'rhs',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
    {
      params: [
        {
          name: 'lhs',
          type: 'scalar',
          optional: false,
          description: 'Scalar.',
        },
        {
          name: 'rhs',
          type: 'scalar',
          optional: false,
          description: 'Scalar.',
        },
      ],
      variadic: false,
      returnType: 'scalar',
    },
  ],
  snapshotOnly: false,
};

export default definition;
